import React,{Component} from 'react';
import './content-right-clients-slider.css';
import Slider from 'react-slick';
import config from '../../../../../config';
import Image_File from '../../../../../Image_File';

class ContentRightClientsSlider extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: {
                price:{},
                meta:{}
            },
            price: {
                price:{}
            },
            isLoaded:false,
            dfd:''
        }
        //config.set(configuration);

    }
    componentDidMount() {
        this.setState({
            data:config.data
        })
    }
    render() {
        var settings = {
            dots: false,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay:true

        };

        let imgTpl= '',
            fnlImg = '';
        let imgPath = 'https://mordorintelligence.com:81/mordorlabs';
        if(config.data.category_id != undefined) {

            try{
                let  indx  = Image_File.children.map((image, index) => {
                    if(image.path == config.data.category_id) {
                        return index;
                    }
                });
                indx = indx.filter(function( element ) {
                    return element !== undefined;
                });

                imgTpl  = Image_File.children[indx].children.map((image, index) => {
                    return (
                        <div class="client_img">
                            <img src={imgPath+"/img/images_clients/"+image.path}  />
                        </div>
                    )
                });

                fnlImg = <div class="report-logo">

                    <Slider {...settings}>
                        {imgTpl}
                    </Slider>
                </div>
            }
            catch (e) {
                imgTpl = '';
                fnlImg ='';
            }



            return(
                <div>
                    {fnlImg}
                </div>
            )
        } else {

            return(
                <div>
                    {/*<div class="report-logo">*/}
                        {/*<Slider {...settings}>*/}
                        {/*<div class="client_img">*/}
                            {/*<img src={"/img/images_clients/55/Alstom.png"}  />*/}
                        {/*</div>*/}
                        {/*</Slider>*/}
                    {/*</div>*/}
                </div>
            )
        }




    }
}

export default  ContentRightClientsSlider;


// WEBPACK FOOTER //
// ./src/report-description/content/content-right/content-right-clients/content-right-clients-slider/content-right-clients-slider.js